// eslint-disable-next-line
export const MENTION_REGEX_G = /\[@([^\]]*)]\(@([^\)]*)\)/g
